/**
 * Catalog tree management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class CatalogTreeManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async getProjectResourceTree(projectUuid: string, resourceType: number | string, fileType?: string, useLevel?: boolean): Promise<Record<string, any>[]> {
    const params: Record<string, any> = { resourceType, projectUuid };
    if (fileType) params.fileType = fileType;
    if (useLevel !== undefined) params.useLevel = useLevel;
    return this.session.get('/api/cdp_catalog_tree/extend/project/queryTree', { params });
  }

  async getTree(resourceType: number | string, isSysRes?: boolean): Promise<Record<string, any>[]> {
    return this.session.get('/api/cdp_catalog_tree/extend/queryTree', { params: { resourceType, isSysRes } });
  }

  async getDeviceTypeTree(category: string, withLeafData?: boolean): Promise<Record<string, any>[]> {
    const params: Record<string, any> = { resourceType: 1, category };
    if (withLeafData) params.withLeafData = withLeafData;
    return this.session.get('/api/cdp_catalog_tree/extend/queryModelTree', { params });
  }

  async getModelTree(resourceType: number | string, category: string, fileType?: string): Promise<Record<string, any>[]> {
    const params: Record<string, any> = { resourceType, category };
    if (resourceType == 7 && fileType) params.fileType = fileType;
    return this.session.get('/api/cdp_catalog_tree/extend/queryModelTree', { params });
  }

  async getSysTree(resourceType: number | string): Promise<Record<string, any>[]> {
    return this.session.get('/api/cdp_catalog_tree/extend/querySysTree', { params: { resourceType } });
  }

  async getUserCatalog(resourceType: number | string): Promise<Record<string, any>[]> {
    return this.session.get('/api/cdp_catalog_tree/extend/queryModelTree', { params: { resourceType, category: 'user' } });
  }

  async getSystemRootNode(resourceType: number | string): Promise<Record<string, any>[]> {
    return this.session.get('/api/cdp_catalog_tree/extend/getSystemRootNode', { params: { resourceType } });
  }

  async modifyResourceCatalog(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_catalog_tree/extend/modifyResourceCatalog', { data });
  }

  async createCatalog(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp_catalog_tree/extend/create', { data });
  }

  async deleteCatalog(uuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/cdp_catalog_tree/delete/${uuid}`);
  }
}
